import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-pink text-white relative overflow-hidden" data-id="element-97">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none" data-id="element-98" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full blur-3xl pointer-events-none" data-id="element-99" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-101">
          <ShieldCheckIcon className="w-20 h-20 mx-auto mb-6 text-white drop-shadow-lg" data-id="element-102" />
          <h2 className="text-4xl md:text-5xl font-display mb-4 drop-shadow-md" data-id="element-103">
            7 DÍAS GARANTÍA TOTAL
          </h2>
          <p className="text-xl font-medium mb-6" data-id="element-104">
            7 días para probarlo o te devolvemos el 100%
          </p>
          <p className="text-white/90 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-105">
            Abrís los módulos, probás los bonos en tu casa o tu gym. Si no es lo
            que esperabas: sin preguntas, sin formularios, sin drama.
          </p>
          <div className="inline-block bg-black/20 px-6 py-2 rounded-full text-sm font-bold tracking-wider uppercase backdrop-blur-sm border border-white/20" data-id="element-106">
            Tasa de devoluciones menor al 1%
          </div>
        </motion.div>
      </div>
    </section>;
}